'use strict';

import {searchMobileDeActivateSS,searchMobileActivateSS} from "../../speedy_screen/scripts/speedy-screen.utils.js";

angular.module('harriApp')
    .controller(
        'searchFiltersController', [
            '$scope',
            'hUser',
            'searchBackend',
            '$timeout',
            '$location',
            '$anchorScroll',
            '$stateParams',
            '$state',
            '$modal',
            'parseUrlQuery',
            'encodeUrlQuery',
            'googleMaps',
            'httpHelper',
            '$interpolate',
            '$q',
            '$filter',
            '$rootScope',
            'ShortListAPI',
            'ShortListData',
            'SS',
            'DispatcherServices',
            '$http',
            '$templateCache',
            '$compile',
            'SavedSearch',
            'deviceChecker',
            'hEvent',
            'hTransitions',
            'userPermissions',
            'inviteToApplyDataService',
            '$element',
            'tagsDataService',
            function(
                $scope,
                hUser,
                searchBackend,
                $timeout,
                $location,
                $anchorScroll,
                $stateParams,
                $state,
                $modal,
                parseUrlQuery,
                encodeUrlQuery,
                googleMaps,
                httpHelper,
                $interpolate,
                $q,
                $filter,
                $rootScope,
                ShortListAPI,
                ShortListData,
                SS,
                DispatcherServices,
                $http,
                $templateCache,
                $compile,
                SavedSearch,
                deviceChecker,
                hEvent,
                hTransitions,
                userPermissions,
                inviteToApplyDataService,
                $element,
                tagsDataService,
            ) {

                var locationTimeoutPromise;
                var minInterval = 500; // ms
                var POSITIONS_CACHE_KEY = 'search_positions';

                const activeTabOptions = {
                    shortlist: 'shortlist',
                    members: 'members',
                }

                $scope.loading = false;

                $scope.isLoggedin = hUser.isLoggedIn();
                $scope.isEmployer = hUser.isEmployer();
                $scope.memberWidgetExperienceLimit = 1;

                $scope.isBigScreen = $(window).width() >= 1920 ? 'big_' : '';


                $scope.isMobile = deviceChecker.isMobile();

                $scope.positions = { 'selectedCategory' : null };

                $scope.sectionsToToggle = ['HECS','cusine','skills','positions','degrees'];
                $scope.onlyImages = false;
                $scope.peopleCount = "";

                $scope.brandId = hUser.isEmployer() && hUser.getUserContext().brand_id;
                $scope.jobsPage = $state.current.name === 'appLayout.harriSH.search.jobs';
                $scope.mainActiveTab = 'employeeJobs';
                $scope.internalJobPostEnabled = false;
                $scope.apiIsLoaded = false;

                $scope.isSelectedFilter = {};
                $scope.appliedFilterValues = {};
                $scope.peoplePageFilters = {
                    LOCATION: {
                        label: $filter('translate')('Location'),
                        code: 'LOCATION',
                        icon: 'fa-map-marker',
                        id: 'location',
                        isVisible: function () {
                            return true;
                        },
                    },
                    POSITIONS: {
                        label: $filter('translate')('Has experience in'),
                        code: 'POSITIONS',
                        icon: 'fa-briefcase',
                        id: 'has-experience-in',
                        isVisible: function () {
                            return $scope.positionsFiltersList && $scope.positionsFiltersList.length;
                        },
                    },
                    YEARS_OF_EXPERIENCE: {
                        label: $filter('translate')('Years of experience'),
                        code: 'YEARS_OF_EXPERIENCE',
                        icon: 'fa-calendar',
                        id: 'years-of-experience',
                        isVisible: function () {
                            return $scope.selectedGroupFilter == 'members';
                        },
                    },
                    TYPE_OF_EXPERIENCE: {
                        label: $filter('translate')('Type of experience'),
                        code: 'TYPE_OF_EXPERIENCE',
                        icon: 'fa-coffee',
                        id: 'type-of-experience',
                        isVisible: function () {
                            return $scope.searchFilters.HECS && $scope.searchFilters.HECS.filters && $scope.searchFilters.HECS.filters.length;
                        },
                    },
                    AVAILABILITY: {
                        label: $filter('translate')('Availability'),
                        code: 'AVAILABILITY',
                        icon: 'fa-clock-o',
                        id: 'availability',
                        isVisible: function () {
                            return ($scope.selectedGroupFilter === 'members');
                        },
                    },
                    PROFILE_IMAGE: {
                        label: $filter('translate')('Profile image'),
                        code: 'PROFILE_IMAGE',
                        icon: 'fa-user',
                        id: 'profile_image',
                        isVisible: function () {
                            return ($scope.selectedGroupFilter === 'members');
                        },
                    },
                    CUISINE: {
                        label: $filter('translate')('Cuisine'),
                        code: 'CUISINE',
                        icon: 'fa-cutlery',
                        id: 'cuisine',
                        isVisible: function () {
                            return $scope.searchFilters.cusine && $scope.searchFilters.cusine.filters && $scope.searchFilters.cusine.filters.length;
                        },
                    },
                    SKILLS: {
                        label: $filter('translate')('Skills'),
                        code: 'SKILLS',
                        icon: 'fa-graduation-cap',
                        id: 'skills',
                        isVisible: function () {
                            return $scope.searchFilters.skills && $scope.searchFilters.skills.filters && $scope.searchFilters.skills.filters.length;
                        },
                    },
                    EDUCATION: {
                        label: $filter('translate')('Education'),
                        code: 'EDUCATION',
                        icon: 'fa-graduation-cap',
                        id: 'education',
                        isVisible: function () {
                            return ($scope.searchFilters.degrees && $scope.searchFilters.degrees.filters && $scope.searchFilters.degrees.filters.length);
                        },
                    },
                };
                $scope.loaderRangesArr = _.range(0, 25);
                var tagsExpandState = {};

                $scope.sortBy = function (sortBy) {
                    $scope.selectedSortType = sortBy;
                };

                $scope.toggleFilter = function (filterCode) {
                    if ($scope.isSelectedFilter[filterCode]) {
                        $scope.removeFilter(filterCode);
                    } else {
                        $scope.isSelectedFilter[filterCode] = true;
                    }
                    $scope.isActiveFilter(filterCode);
                }

                $scope.isActiveFilter = function (filterCode) {
                    $(document).on('mousedown', function (event) {
                        var $target = $(event.target);
                        if (!$target.closest('.filter-wrapper').length) {
                            $scope.isActiveFilter('NO_FILTER_SELECTED')
                            $(document).off('mousedown');
                            $scope.$digest();
                        }
                    })
                    for (const filter in $scope.peoplePageFilters) {
                        if (filterCode != $scope.peoplePageFilters[filter].code) {
                            $scope.peoplePageFilters[filter].isActive = false;
                        } else {
                            $scope.peoplePageFilters[filter].isActive = true;
                        }
                    }
                }

                $scope.onFilterContentClicked = function(event) {
                    event.stopPropagation();
                }

                $scope.onExpandTagsSection = function (tagGroup) {
                    tagsExpandState[tagGroup.id] = tagGroup.shown;
                };

                if (hUser.isLoggedIn()) {
                    CandidateAPI.candidateBrandServicesCheck('PRIVATE_JOB_POST', true, true)
                        .then(function (data) {
                            if (data.brands && data.brands.length) {
                                $scope.internalJobPostEnabled = true;
                            }
                            $scope.apiIsLoaded = true;
                            $scope.$digest();
                        });
                }

                // Search parameters object, used by both search and speedy screen data loaders
                var params = {};
                var previousSearchParams = undefined;
                var previousSearchGroup = undefined;
                var previousSelectedTab = undefined;
                var bindingInterval;

                $scope.showEmployerQuickRegisterModal = function () {
                    $modal({
                        controller: 'EmployerQuickRegisterModalController',
                        templateUrl: '../modules/emp_quick_reg/views/employer_quick_register_modal.html',
                        show: true,
                        resolve: {}
                    });
                };

                $scope.onTabSelected = function (tab) {
                    $scope.mainActiveTab = tab;
                    $scope.doDelayedSearch();
                };

                var getContextBrand = function () {
                    var brand = hUser.getUserContext();

                    return {
                        id: brand.brand_id,
                        type: brand.brand_type
                    };
                };

                /**
                 * load member into speedy screen modal
                 * @param memberId member id to show speedy screen for
                 */

                $scope.setActiveTab = function (tab) {
                    $scope.activeTab = tab;
                    $($element.find('.speedy-scrollable-content')).scrollTop(0);
                };

                var prepareTagsExpandMap = function () {
                    var tagsExpandMap = {};
                    var tagTypes = angular.copy(tagsDataService.TAGS_TYPES);
                    for (var i in tagTypes) {
                        tagsExpandMap[tagTypes[i]] = true;
                    }

                    return tagsExpandMap;
                };

                var showSpeedyScreenItem = function(activeMemberId) {

                    var initialSpeedyIds = [];
                    tagsExpandState = prepareTagsExpandMap();


                    if ($scope.selectedGroupFilter == 'members' || $scope.selectedGroupFilter == 'all') {
                        for (var i in $scope.searchResults.members.results) {
                            initialSpeedyIds.push({id: $scope.searchResults.members.results[i].id});
                        }
                    }
                    else if ($scope.selectedGroupFilter == 'shortlist') {
                        for (var i in $scope.shortListedUsers) {
                            initialSpeedyIds.push({id: $scope.shortListedUsers[i]});
                        }
                    }

                    $scope.activeId = 0;

                    var scopes_ref = [];
                    $('#speedy-search-modal').speedyX({
                        'loadIds': function(loadedIds) {
                            var defer = jQuery.Deferred();

                            if (loadedIds == 0) {
                                // Start speedy screen with same ids as in search result
                                defer.resolve(initialSpeedyIds);
                            }
                            else {
                                // Load new ids for speedy screen pagination
                                if ($scope.selectedGroupFilter == 'members' || $scope.selectedGroupFilter == 'all') {
                                    var speedySearchParams = searchBackend.prepareDataBeforeSend('members' , params);

                                    speedySearchParams.size = 40;
                                    speedySearchParams.start = loadedIds;
                                    speedySearchParams.only_ids = true;

                                    httpHelper.p(publicConfiguration.APIServerBaseURL + 'harri_search/search_users', speedySearchParams).then(function(res) {
                                        var ids = [];

                                        for (var i in res.data.data.results) {
                                            ids.push({id: res.data.data.results[i]});
                                        }

                                        defer.resolve(ids);
                                    });
                                }
                                else {
                                    defer.resolve([]);
                                }
                            }

                            return defer.promise();
                        },
                        'loadIdsData': function (ids) {
                            var defersMap = {};
                            var promises = [];

                            ids.forEach(function(id){
                                var defer = $q.defer();
                                defersMap[id] = defer;
                                promises.push(defer.promise);
                            });

                            var dataReadyHandler = function(id, memberData) {
                                memberData.id = memberData.user_info.id;
                                defersMap[id].resolve([memberData]);
                            };

                            var loadDataForIds = function() {
                                ids.forEach(function(memberId) {
                                    if (memberId != activeMemberId) {
                                        CoreReaderAPI.getMemberProfile(memberId).then(function(res) {
                                            dataReadyHandler(memberId, res.data.data);
                                        });
                                    }
                                });
                            }

                            if (ids.indexOf(activeMemberId) >= 0) {
                                CoreReaderAPI.getMemberProfile(activeMemberId).then(function(res){
                                    dataReadyHandler(activeMemberId, res.data.data);
                                    loadDataForIds();
                                });
                            }
                            else {
                                loadDataForIds();
                            }
                            if (hUser.isEmployer()) {
                                CoreReaderAPI.getBrandBusinessSettings($scope.brandId)
                                    .then((res) => {
                                        $scope.isEducationDatesMandatory = res.settings.is_education_dates_mandatory;
                                    })
                            } else {
                                $scope.isEducationDatesMandatory = false;
                            }


                            return promises;
                        },
                        'range': 3,
                        'template': '../modules/candidate_card/views/search_candidate_card.tmpl.html',
                        'allowPagination': true,
                        'limitBulkLoading': true,
                        'isMobile':$scope.isMobile,
                        'additionalData': {
                        },
                        'onHide': function ($element) {
                            $element.find('.candidate-card-modal').each(function () {
                                var slideScope = $(this).scope();
                                if (slideScope && slideScope.speedySearchData) {
                                    slideScope.$destroy();
                                }
                            });

                            $('#speedy-search-modal').speedyX('destroy');
                            searchMobileDeActivateSS();
                        },
                        'onRendered': function (element, data) {
                            var card_scope;
                            card_scope = $scope.$new();
                            card_scope.speedySearchData = data;
                            card_scope.speedySearchData.fullName = `${card_scope.speedySearchData.user_info.first_name} ${card_scope.speedySearchData.user_info.last_name}`;
                            card_scope.speedySearchData.markAsSilverMedalist = false;
                            card_scope.speedySearchData.isSilverToggleVisible = $scope.selectedGroupFilter !== activeTabOptions.members && $scope.selectedGroupFilter !== activeTabOptions.shortlist;

                            if ($scope.isEmployer) {
                                card_scope.speedySearchData.contextBrand = getContextBrand();
                                card_scope.speedySearchData.activeBrandId = hUser.getUserHighestBrandAccess().brand_id ||  hUser.getUserHighestBrandAccess().id;

                                inviteToApplyDataService.getCandidateInvitesToApply(
                                    card_scope.speedySearchData.activeBrandId,
                                    card_scope.speedySearchData.user_info.id
                                )
                                    .then(function (res) {
                                        card_scope.speedySearchData.invitesToApply = res.job_invites;
                                    }, function (err) {
                                        console.error(err);
                                    });
                            }
                            card_scope.speedySearchData.tagsExpandState = tagsExpandState;

                            /* find Full Image URL */
                            card_scope.speedySearchData.profileImageFullURL = $filter("hUserProfileImage")([card_scope.speedySearchData.profile_image, card_scope.speedySearchData.user_info.id],"_image_profile_full",true);
                            if( $state.current.name.indexOf('people') != -1 &&  $scope.talentPoolCandidates.indexOf( data.id ) != -1 ){
                              card_scope.speedySearchData.isInTalentPool = true;
                            }

                            card_scope.candidateTags = [];
                            $compile(element)(card_scope);
                            card_scope.$apply();
                            scopes_ref[data.id] = card_scope;
                        },
                        'afterChange': function (activeId, $element, $activeElement) {
                            $scope.activeId = activeId;
                            $scope.setActiveTab('OVERVIEW');
                        },
                        'onScroll': function ($element, $activeElement) {
                        },
                        'containerClass':function(){
                            return '';
                        },
                        'beforeRemoveSlide': function(index, $ele){
                            // we need the scope of the kid
                            var slideScope = $ele.find('.candidate-card-modal').scope();
                            if( slideScope ){
                               slideScope.$destroy();
                            }
                        }, 'loadSpeedyArrowsViewData': function (cardId, leftEdgedReached, rightEdgedReached) {
                            var defer = $q.defer();
                            var speedyXData;

                            if ($scope.selectedGroupFilter == 'members' || $scope.selectedGroupFilter == 'all') {
                                speedyXData = $scope.searchResults.members.results;
                            } else if ($scope.selectedGroupFilter == 'shortlist') {
                                speedyXData = $scope.shortlistMembers;
                            }

                            if (speedyXData) {
                                var userIndex = speedyXData.findIndex(function (member) {
                                    return member.id == cardId;
                                });

                                if (userIndex > -1) {
                                    var previousEmployee = userIndex >= 1 ? speedyXData[userIndex - 1] : null;
                                    var nextEmployee = (userIndex < speedyXData.length - 1) ? speedyXData[userIndex + 1] : null;

                                    if (leftEdgedReached) {
                                        nextEmployee = speedyXData[userIndex];
                                    }

                                    if (rightEdgedReached) {
                                        previousEmployee = speedyXData[userIndex];
                                    }

                                    var arrowsViewData = {};

                                    if (nextEmployee) {
                                        arrowsViewData.nextEmployee = {
                                            user_id: nextEmployee.id,
                                            first_name: nextEmployee.firstName,
                                            last_name: nextEmployee.lastName,
                                            profile_image_uuid: nextEmployee.profileImageUUID,
                                            position: nextEmployee.position ? {name: nextEmployee.position.name + ' | ' + $filter('formatYearsOfExperience')(nextEmployee.position.startDate, nextEmployee.position.endDate, $filter('translate')('experience'))} : null,
                                        };
                                    }

                                    if (previousEmployee) {
                                        arrowsViewData.previousEmployee = {
                                            user_id: previousEmployee.id,
                                            first_name: previousEmployee.firstName,
                                            last_name: previousEmployee.lastName,
                                            profile_image_uuid: previousEmployee.profileImageUUID,
                                            position: previousEmployee.position ? {name: previousEmployee.position.name + ' | ' + $filter('formatYearsOfExperience')(previousEmployee.position.startDate, previousEmployee.position.endDate, $filter('translate')('experience'))} : null,
                                        };
                                    }

                                    defer.resolve(arrowsViewData);
                                }
                            }

                            return defer.promise;
                        },
                        'showArrowsData': true,
                    });

                    $('#speedy-search-modal').speedyX('show', activeMemberId, false);
                };

              /**
               * Handle showing speedy screen starting from a specific member id
               * @param event
               * @param id
               */
                $scope.showSpeedyScreen = function(event, id) {
                  event.stopPropagation();
                  event.preventDefault();

                  if(  deviceChecker.isTinyScreen() ){
                    searchMobileActivateSS();
                  }

                  showSpeedyScreenItem(id);
                };

                $scope.speedyScreenNext = function() {
                    var e = jQuery.Event("keydown");
                    e.which = 39; // Right key code
                    $(document).trigger(e);
                }

                if (hUser.isLoggedIn()) {
                    if (!window.membersCount) {
                        var membersCount = searchBackend.getMembers({
                            'search_phrase': "",
                            "limitations": 1,
                            'start': 0,
                            'onlyImages': false
                        });
                        membersCount.promise.then(function (resp) {
                            $timeout(function () {
                                $scope.peopleCount = resp.data.data.hits;
                            });
                        });
                    } else {
                        $scope.peopleCount = window.membersCount;
                    }
                }

                var unhookTransitionStart = hTransitions.onStart({}, function (trans) {

                    var toState = trans.to();
                    var toParams = trans.params("to");
                    var fromState = trans.from();

                    if (toState.name && toState.name.indexOf("appLayout.harriSH.search.") != 0) {
                        // If we are going out of search pages, unsubscribe the event listener
                        unhookTransitionStart();
                    }

                    if (fromState.name == toState.name) {
                        // If state is changed, but the state name is the same this means the filters has been changed
                        // Apply these filters by parsing the search object from the query
                        var searchObj = parseUrlQuery(decodeURI($state.href(toState.name, toParams)));
                        parseQuerySearchObject(searchObj);
                    }
                    else {
                        /**
                         * Close SpeedyScreen
                         */
                        $('#speedy-search-modal').speedyX('destroy');
                    }
                });

                var unhookTransitionSuccess = hTransitions.onSuccess({}, function (trans) {
                    var fromState = trans.from();
                    var toState = trans.to();
                    if (toState.name && toState.name.indexOf("appLayout.harriSH.search.") != 0) {
                        // If we are going out of search pages, unsubscribe the event listener
                        unhookTransitionSuccess();
                    }

                    if (toState.name && toState.name != fromState.name && $scope.changeFilter) {
                        switch (toState.name) {
                            case 'appLayout.harriSH.search.jobs' :
                                $scope.changeFilter('jobs');
                                break;
                            case 'appLayout.harriSH.search.apprentice-jobs' :
                                $scope.changeFilter('apprentice_jobs');
                                break;
                            case 'appLayout.harriSH.search.pride-apprentice-jobs' :
                                $scope.changeFilter('pride_apprentice_jobs');
                                break;
                            case 'appLayout.harriSH.search.people' :
                                $scope.changeFilter('members');
                                break;
                            case 'appLayout.harriSH.search.companies' :
                                $scope.changeFilter('companies');
                                break;
                            case 'appLayout.harriSH.search.shortlist' :
                                $scope.changeFilter('shortlist');
                                break;
                            case 'appLayout.harriSH.search.all' :
                                $scope.changeFilter('all');
                                break;
                        }
                    }

                });



                /**
                 * Short List Functions
                 */
                $scope.shortListMembersCount = ShortListData.membersCount;
                $scope.shortListedUsers = ShortListData.listIds;
                $scope.shortlistMembers = ShortListData.shortlistMembers;
                $scope.shortListTimeOut = 0;
                $scope.usersIdsArry = [];


                /**
                 * Short List Entrypoint to get The Basic Data for Shortlist
                 * only for the loggedin and Employer users
                 */
                $scope.initShortlist = function(){
                  if( hUser.isLoggedIn() && hUser.data.user.user_employer ){
                    ShortListData.init();
                  }
                }

                /* Lsn to Shortlist data update */
                $scope.$on('ShortListData.updated', function( data ){
                  $scope.shortListMembersCount = ShortListData.membersCount;
                  $scope.shortListedUsers = ShortListData.listIds;
                  $scope.shortlistMembers = ShortListData.shortlistMembers;
                });

                /* Call the Sortlist Init */
                $scope.initShortlist();

                /**
                 *
                 */
                $scope.usersAddedSuccessfully = false;
                var successMessageTimeout = 0;

                $scope.userAddedToShortList = function(  ){
                  $scope.usersAddedSuccessfully = true;
                  $timeout.cancel( successMessageTimeout );
                  successMessageTimeout = $timeout(function(){
                    $scope.usersAddedSuccessfully = false;
                  }, 2000);
                }

                $scope.inviteMemberToApply = function(memberId) {
                  ShortListData.fireInviteToApply(memberId);
                  $('#speedy-search-modal').speedyX('destroy');
                }

                $scope.removeMemberFromShortlist = function(memberId) {
                  ShortListAPI.removeMembers([memberId]).then(function(res) {
                    if (res.data.status_code == 200) {
                      ShortListData.listIds.splice(ShortListData.listIds.indexOf(memberId), 1);
                      ShortListData.membersCount = ShortListData.listIds.length;
                      ShortListData.broadcastData();
                      ShortListData.broadcastDeleted(memberId);
                    }
                  })
                }

                /**
                 * Add User To ShortList
                 * @param userid
                 */
                $scope.addedMembers = [];
                $scope.addMemberToShortList = function( userid ){
                  /* Check if the user loggedin and is Employer */
                  if( !hUser.isLoggedIn() ){
                    //  display not logged in user
                    $('#unloggedin-user .modal').modal('show');
                    $('#unloggedin-user .modal .get-started').on('click', function (e) {
                        $('#unloggedin-user .modal').modal('hide');
                        $('.modal-open').removeClass('modal-open');
                        Utils.redirectToWorkspace('registration.employer', {redirectToUrl: encodeURIComponent($state.href('appLayout.harriSH.search.people'))});
                    });
                    return;
                  }else if(hUser.isLoggedIn() && !hUser.data.user.user_employer){
                    // display user is not employer
                    $('#not-employer-user .modal').modal('show');
                    return;
                  }

                  $timeout.cancel( $scope.shortListTimeOut );

                  if( _.indexOf($scope.usersIdsArry,userid) == -1 ){
                    $scope.usersIdsArry.push( userid );

                    $scope.addedMembers.push( _.findWhere( $scope.searchResults.members.results , {'id' : userid } ) );

                  }

                  $('.member-'+userid).button('loading');
                  $('.member-widget-'+userid).addClass('loading');

                  /* to prevent sending multiple requests */
                  $scope.shortListTimeOut = $timeout(function(){

                    ShortListAPI.addMembers($scope.usersIdsArry, $scope.brandId).then((resp) => {
                      if( resp.data.status_code == 200 ){
                              //Replace the User
                          replaceTheShortlistedMembers([userid]);
                        ShortListData.listIds = _.union( ShortListData.listIds, _.pluck( resp.data.data , 'user_id' ) );
                        ShortListData.membersCount = ShortListData.listIds.length;
                        ShortListData.broadcastData();

                        $scope.memberAddedToShortlistText = "";
                        if( resp.data.data.length == 1 ){
                          var memberId = _.pluck( resp.data.data , 'user_id' );
                          var member = _.findWhere($scope.addedMembers, {'id' : memberId[0] } );

                          if( member ){
                            $scope.memberAddedToShortlistText = member.firstName+' '+member.lastName+' '+$filter("translate")("was");
                          }

                        }else{
                          $scope.memberAddedToShortlistText = resp.data.data.length + " "+$filter("translate")("Candidates were");
                        }


                        /**
                         * Always do a clear for this Arr
                         */
                        if( _.size( $scope.addedMembers ) > 10 ){
                          $scope.addedMembers = _.last( $scope.addedMembers ,  _.size( $scope.addedMembers ) - 5 );
                        }

                        /**
                         * Replace the added users with another user
                         */
                        //$scope.replaceTheShortlistedMembers( _.pluck( resp.data.data , 'user_id' ) );


                        var btnsClass = _.map( ShortListData.listIds , function(id){ return '.member-'+id } );
                        var widgetsClass = _.map( ShortListData.listIds , function(id){ return '.member-widget-'+id } );
                        $( btnsClass.join(', ')).button('reset');
                        $( widgetsClass.join(', ')).removeClass('loading');

                        $scope.usersIdsArry = _.difference( $scope.usersIdsArry , _.pluck( resp.data.data , 'user_id' ) );

                        $timeout(function(){
                          $scope.$apply();
                        });

                        $scope.userAddedToShortList();
                      }
                    }).catch((error) => {
                        if (error?.message === BrandAPI.PROFILE_TYPES_ERROR_CODES.CANNOT_APPLY) {
                            let text = $scope.usersIdsArry.length === 1 ? $scope.addedMembers[0].firstName + ' ' + $scope.addedMembers[0].lastName + ' ' + $filter("translate")("has an employment profile under your account, please add their profile directly to the talent pool instead.") : $filter("translate")("Some of the selected candidates already have an employment profile under your account, please add their profile directly to the talent pool instead.")
                            hAlert({
                                title: $filter("translate")("Error"),
                                text: text,
                            });
                        } else {
                            hAlert({
                                title: $filter("translate")("Error"),
                                text: $filter("translate")("An unexpected error occurred. Please try again."),
                            });
                        }
                        $('.member-' + userid).button('reset');
                        $('.member-widget-' + userid).removeClass('loading');
                    });

                  },500);



                }

                /**
                 * Replace the Added users with another users from the end of the search
                 * and Do pagination if needed if the length of the available users
                 *
                 * @params : Array of Users Ids
                 */
                var replaceTheShortlistedMembers = function (usersIds) {

                    var promises = [];

                    var tmpMemberIndex, tmpLastMember, memberIds, lastMemberId;
                    usersIds = usersIds || [];

                    usersIds.forEach(function (userId) {

                        var defer = $q.defer();
                        promises.push(defer.promise);

                        tmpMemberIndex = _.indexOf($scope.searchResults.members.results, _.findWhere($scope.searchResults.members.results, {'id': userId}));
                        tmpLastMember = _.last($scope.searchResults.members.results);

                        /**
                         * Get only unshortlisted users
                         */
                        var tmpShortListedIds = _.union(ShortListData.listIds, usersIds);
                        memberIds = _.difference(_.pluck($scope.searchResults.members.results, 'id'), tmpShortListedIds);


                        /**
                         * Only replace if we have ability to do a shortlist
                         */
                        if (memberIds.length) {
                            lastMemberId = memberIds[memberIds.length - 1];

                            tmpLastMember = _.findWhere($scope.searchResults.members.results, {'id': lastMemberId});

                            if (tmpMemberIndex != -1) {

                                /**
                                 * Replace in Array
                                 */
                                $scope.searchResults.members.results.splice(_.indexOf($scope.searchResults.members.results, tmpLastMember), 1);
                                $scope.searchResults.members.results[tmpMemberIndex] = tmpLastMember;


                                if ($('#speedy-search-modal') && $('#speedy-search-modal').speedyX) {
                                    $('#speedy-search-modal').speedyX('replaceItem', userId, lastMemberId);
                                }

                                /**
                                 * Replace HTML
                                 */
                                $('.member-widget-' + tmpLastMember.id).parent().remove();

                                getMemberCardHtml(tmpLastMember, function (html) {
                                    $('.member-widget-' + userId).replaceWith($compile(html)($scope));
                                    $scope.$apply(function () {
                                        $('.member-widget-' + tmpLastMember.id).addClass('swipt');
                                    });

                                    defer.resolve();
                                });
                            }
                            else {
                                defer.reject();
                            }

                        } else {
                            /**
                             * if there is no appility to replace
                             */
                            var shortlistedUser = _.findWhere($scope.searchResults.members.results, {'id': userId});

                            getMemberCardHtml(shortlistedUser, function (html) {
                                $('.member-widget-' + userId).replaceWith($compile(html)($scope));
                                defer.resolve();
                            });
                        }

                        $scope.shortListedUsers.push(userId);
                    });

                    return $q.all(promises);
                }

                /**
                 * END Short List Functions
                 */


                /**
                 * =========================================================
                 *                   Talent pool candidates
                 * =========================================================
                 */
                $scope.talentPoolCandidates = [];

                $rootScope.$on('candidate-tag-added', function (event, data) {

                    if (!_.isArray($scope.talentPoolCandidates)) {
                        $scope.talentPoolCandidates = [];
                    }

                    if ($scope.talentPoolCandidates.indexOf(data.candidate_id) == -1) {
                        $scope.talentPoolCandidates.push(data.candidate_id);

                        if ($scope.searchResults && $scope.searchResults.members && $scope.searchResults.members.results) {
                            var candidate = _.findWhere($scope.searchResults.members.results, {id: data.candidate_id});
                            if ($state.current.name.indexOf('shortlist') == -1) {
                                getMemberCardHtml(candidate, function(html) {
                                    $('.member-widget-' + data.candidate_id).replaceWith($compile(html)($scope));
                                })
                            }
                        }
                    }

                });

                $rootScope.$on('shortlisted-to-talentpool',function( event , listOfCandidates ){

                  if( !_.isArray($scope.talentPoolCandidates) ){
                    $scope.talentPoolCandidates = [];
                  }

                  $scope.talentPoolCandidates = _.union( $scope.talentPoolCandidates , listOfCandidates );

                });

                /**
                 * ============= End of Talent pool Candidates =============
                 */

                // Opened Sections
                $scope.openedSections = {
                    'HECS'   : false,
                    'cusine' : false,
                    'skills' : false,
                    'positions': false,
                    'degrees':false
                };

                // Years of Experience
                $scope.yearsOfExperience = [
                {
                    value: 0,
                    label: $filter("translate")("+0 Years")
                },
                {
                    value: 1,
                    label: $filter("translate")("+1 Year")
                },{
                    value: 2,
                    label: $filter("translate")("+2 Years")
                },{
                    value: 3,
                    label: $filter("translate")("+3 Years")
                },{
                    value: 4,
                    label: $filter("translate")("+4 Years")
                },{
                    value: 5,
                    label: $filter("translate")("+5 Years")
                }];

                // User Availability
                $scope.availability = [
                    {
                        value: 'any_time',
                        label: $filter("translate")("Anytime")
                    },
                    {
                        value: 'full_time',
                        label: $filter("translate")("Full Time")
                    },
                    {
                        value: 'part_time',
                        label: $filter("translate")("Part Time")
                    }
                ];

                $scope.locationLabel;

                // Array of distance radius options
                $scope.locationDistanceOptions = [
                    {label: $filter("translate")("Within 0.5 mile"), value: 0.5},
                    {label: $filter("translate")("Within 1 mile"), value: 1},
                    {label: $filter("translate")("Within 2 miles"), value: 2},
                    {label: $filter("translate")("Within 3 miles"), value: 3},
                    {label: $filter("translate")("Within 5 miles"), value: 5},
                    {label: $filter("translate")("Within 10 miles"), value: 10},
                    {label: $filter("translate")("Within 15 miles"), value: 15},
                    {label: $filter("translate")("Within 20 miles"), value: 20},
                    {label: $filter("translate")("Within 30 miles"), value: 30},
                    {label: $filter("translate")("Within 40 miles"), value: 40},
                    {label: $filter("translate")("Within 50 miles"), value: 50},
                    {label: $filter("translate")("Within 75 miles"), value: 75},
                    {label: $filter("translate")("Within 100 miles"), value: 100},
                    {label: $filter("translate")("Within 150 miles"), value: 150},
                    {label: $filter("translate")("Within 200 miles"), value: 200}
                ];

                const DEFAULT_SELECTED_DISTANCE_INDEX = $scope.locationDistanceOptions.length - 1;

                $scope.selectedAvailability = [];

                // Positions Limitation
                $scope.defaultPositionsLimitation = 8;

                $scope.positionsLimitation = {};



                // Search results that returned from the API
                $scope.searchResults = {
                    'jobs': {
                        'count': 0,
                        'results': []
                    },
                    'apprentice_jobs': {
                        'count': 0,
                        'results': []
                    },
                    'pride_apprentice_jobs': {
                        'count': 0,
                        'results': []
                    },
                    'members': {
                        'count': 0,
                        'results': []
                    },
                    'companies': {
                        'count': 0,
                        'results': []
                    }
                };

                // Sorting Categories
                $scope.sortByRelevancyEntry = {
                    'label': $filter("translate")("Relevance"),
                    'sort_type': 'desc',
                    'field': '_score',
                    'id': 'RELEVANCE',
                };

                $scope.sortedBy = [{
                    'label': $filter("translate")("Newest"),
                    'sort_type': 'desc',
                    'field': 'created',
                    'id': 'NEWEST',
                }, {
                    'label': $filter("translate")("Oldest"),
                    'sort_type': 'asc',
                    'field': 'created',
                    'id': 'OLDEST',
                }, {
                    'label': $filter("translate")("Last Modified"),
                    'sort_type': 'desc',
                    'field': 'updated',
                    'id': 'LAST_MODIFIED',
                }];

                /** @todo
                 * reset it to [0]
                 */
                $scope.selectedSortType = $scope.sortedBy[0];

                $scope.page = 0;


                $scope.initFilters = function () {
                    return {
                        'HECS': [],
                        'cusine': [],
                        'skills': [],
                        'positions': [],
                        'availability': [],
                        'degrees': []
                    };
                }

                $scope.selectedFilters = $scope.initFilters();


                $scope.selectedCategories = [];

                $scope.timeouts = {};

                $scope.resultsCount = {
                    'jobs': 5,
                    'big_jobs' : 7,
                    'apprentice_jobs': 5,
                    'pride_apprentice_jobs': 5,
                    'big_apprentice_jobs' : 7,
                    'members': 12,
                    'big_membes' : 16,
                    'companies': 5,
                    'big_companies' : 7,
                };

                $scope.searchFilters = {};
                $scope.searchFiltersLimitations = {
                    'default': 11,
                    'skills': 11,
                    'HECS': 11,
                    'cusine': 11,
                    'positions': 11,
                    'degrees':11
                };

                $scope.searchFiltersRequest = {
                    keywords: '',
                    locations: {},
                }

                // Set default distance radius to first option (100 mile)
                $scope.searchFiltersRequest.radius = $scope.locationDistanceOptions[DEFAULT_SELECTED_DISTANCE_INDEX];

                $scope.defaultLimitations = {
                    'all': {
                        'jobs': 5,
                        'big_jobs' : 7,
                        'apprentice_jobs': 5,
                        'pride_apprentice_jobs': 5,
                        'big_apprentice_jobs' : 7,
                        'members': 12,
                        'big_members' : 16,
                        'companies': 5,
                        'big_companies' : 7
                    },
                    'jobs': {
                        'jobs': 10,
                        'big_jobs' : 28,
                        'apprentice_jobs': 0,
                        'pride_apprentice_jobs': 0,
                        'big_apprentice_jobs' : 0,
                        'members': 0,
                        'big_members' : 0,
                        'companies': 0,
                        'big_companies' : 0

                    },
                    'apprentice_jobs': {
                        'jobs': 0,
                        'big_jobs' : 0,
                        'apprentice_jobs': 10,
                        'big_apprentice_jobs' : 28,
                        'members': 0,
                        'big_members' : 0,
                        'companies': 0,
                        'big_companies' : 0
                    },
                    'pride_apprentice_jobs': {
                        'jobs': 0,
                        'big_jobs' : 0,
                        'apprentice_jobs': 10,
                        'pride_apprentice_jobs': 10,
                        'big_apprentice_jobs' : 28,
                        'members': 0,
                        'big_members' : 0,
                        'companies': 0,
                        'big_companies' : 0
                    },
                    'members': {
                        'jobs': 0,
                        'big_jobs' : 0,
                        'apprentice_jobs': 0,
                        'pride_apprentice_jobs': 0,
                        'big_apprentice_jobs' : 0,
                        'members': 18,
                        'big_members' : 70,
                        'companies': 0,
                        'big_companies' : 0
                    },
                    'companies': {
                        'jobs': 0,
                        'big_jobs' : 0,
                        'apprentice_jobs': 0,
                        'pride_apprentice_jobs': 0,
                        'big_apprentice_jobs' : 0,
                        'members': 0,
                        'big_members' : 0,
                        'companies': 10,
                        'big_companies' : 35,
                    }
                };

                $scope.currentLimitations = {
                    'jobs': 5,
                    'big_jobs' : 7,
                    'apprentice_jobs': 5,
                    'pride_apprentice_jobs': 5,
                    'big_apprentice_jobs' : 7,
                    'members': 12,
                    'big_members' : 14,
                    'companies': 5,
                    'big_companies' : 7
                };

                $scope.isLoadMorePageDisabled = false;

                $scope.togglePositionsLimit = function( $event ){


                    if( $scope.positions.selectedCategory.limitaion == undefined ){
                        $scope.positions.selectedCategory.limitaion = $scope.defaultPositionsLimitation;
                    }
                    if ($scope.positions.selectedCategory.limitaion) {
                        if ($scope.positions.selectedCategory.limitaion != $scope.defaultPositionsLimitation ) {
                            $scope.positions.selectedCategory.limitaion = $scope.defaultPositionsLimitation;
                            angular.element('.positions-limit span.text').text('View All');
                        }else{
                            $scope.positions.selectedCategory.limitaion = $scope.positions.selectedCategory.PositionType.Position.length;
                            angular.element('.positions-limit span.text').text('close');
                        }
                    };
                }

                $scope.applyPositionsFilter = function () {
                    $scope.appliedFilterValues.POSITIONS = $scope.searchFilters.positions.selectedFilters && $scope.searchFilters.positions.selectedFilters.length && ($scope.searchFilters.positions.selectedFilters.length == 1 ? $scope.searchFilters.positions.selectedFilters[0].name : $scope.searchFilters.positions.selectedFilters.length + ' ' + $filter('translate')('Selected'));
                    self.isPositionFilterApplied = true;
                    $scope.doSearch();
                };

                $scope.doPagination = function() {

                    if ($scope.selectedGroupFilter != 'all' && !$scope.isLoadMorePageDisabled) {
                        $scope.isLoadMorePageDisabled = true;

                        $scope.page++;
                        $scope.doSearch(true);
                    }

                };

                $scope.toggleCategory = function( category ){
                    category.shown = !category.shown;
                }


                $scope.changeSort = function() {

                    $scope.page = 0;
                    $scope.currentLimitations = angular.copy($scope.defaultLimitations[$scope.selectedGroupFilter]);


                    $timeout(function() {
                        angular.element('.search-filters button').focusout();
                    });

                    $scope.doSearch();

                }

                $scope.toggleLimitTo = function(groupName, $event) {

                    if ($scope.searchFiltersLimitations[groupName] == $scope.searchFiltersLimitations.default) {

                        if (groupName != 'positions') {
                            $scope.searchFiltersLimitations[groupName] = $scope.searchFilters[groupName].filters.length;
                        } else {
                            $scope.searchFiltersLimitations[groupName] = $scope.searchFilters[groupName][0].PositionType.Position.length;
                        }

                        angular.element($event.currentTarget).find('span.text').text('Close');

                    } else {
                        $scope.searchFiltersLimitations[groupName] = $scope.searchFiltersLimitations.default;
                        angular.element($event.currentTarget).find('span.text').text('View All');
                    }


                };


                 $scope.changeFilter = function(filterCode) {
                     $scope.selectedGroupFilter = filterCode;

                    if(filterCode == 'members' && $scope.sortedBy.length && $scope.sortedBy[0].field != '_score'){
                        $scope.sortedBy.unshift( $scope.sortByRelevancyEntry );
                        // set default selected sort type when change the array
                        $scope.selectedSortType = $scope.sortedBy[0];
                    }
                    else if(filterCode != 'members' && $scope.sortedBy.length && $scope.sortedBy[0].field == '_score') {
                        ar_delete( $scope.sortedBy, 0);
                        // set default selected sort type when change the array
                        $scope.selectedSortType = $scope.sortedBy[0];
                    }

                    $scope.peoplePageFilters.POSITIONS.label = $scope.selectedGroupFilter == 'members' ? $filter('translate')('Has experience in') : $filter('translate')('Position');
                    $scope.peoplePageFilters.TYPE_OF_EXPERIENCE.label = $scope.selectedGroupFilter == 'members' ? $filter('translate')('Type of experience') : $filter('translate')('Type');

                    $timeout(function() {
                        $scope.$digest();
                    });

                     $scope.selectedGroupFilter = filterCode;
                    if( filterCode != 'shortlist' ){
                      $scope.page = 0;

                      if ($scope.selectedGroupFilter == 'all') {
                        $scope.resultsCount = angular.copy($scope.defaultLimitations.all);
                      } else {
                        $scope.resultsCount[$scope.isBigScreen+filterCode] = $scope.searchResults[filterCode].count;
                      }

                      $scope.currentLimitations = angular.copy($scope.defaultLimitations[filterCode]);

                      $timeout(function() {
                        $scope.$digest();
                      })

                      $scope.doDelayedSearch();
                    }else{
                      $scope.resetFilters( true );
                      $scope.selectedGroupFilter = filterCode;
                      $scope.page = 0;
                    }
                };


                $scope.groupFilters = [{
                    displayName: $filter("translate")("all"),
                    code: 'all',
                    url : 'appLayout.harriSH.search.all'
                }, {
                    displayName: $filter("translate")("jobs"),
                    code: 'jobs',
                    url : 'appLayout.harriSH.search.jobs'
                }, {
                    displayName: $filter("translate")("companies"),
                    code: 'companies',
                    url : 'appLayout.harriSH.search.companies'
                }, {
                    displayName: $filter("translate")("people"),
                    code: 'members',
                    url : 'appLayout.harriSH.search.people'
                }];

                hUser.isFromUK()
                    .then(function (fromEU) {
                        $scope.isFromUK = fromEU;
                        if ($scope.isFromUK) {
                            // Remove people
                            $scope.groupFilters.splice(3, 1);
                            $scope.mainActiveTab = 'myEmployerJobs';
                        } else {
                            $scope.mainActiveTab = 'employeeJobs';
                        }
                        setTimeout(function () {
                            $scope.$digest();
                        }, 100);
                    });

                $scope.selectedGroupFilter = 'all';

                $scope.selectedRanges = 1;

                $scope.positionsListOptions = {
                    allowClear: false,
                    multiple: true,
                };
                $scope.selectedPositions = [];


                var getLocationName = function(location){
                  if (!location.description) {

                      // Set location label by default to location key
                      location.description = location.location_key;

                    $scope.searchFiltersRequest.locations = location;

                    //Select Distance Sort
                    var sortByDistanceIndex = _.indexOf( $scope.sortedBy, _.findWhere( $scope.sortedBy, {'field' : 'location'} ) );
                    if( sortByDistanceIndex != -1 ){
                      $scope.selectedSortType = $scope.sortedBy[sortByDistanceIndex];
                    }



                    googleMaps.locationAutocomplete(location.lat+","+location.lng).then(function( data ){

                      if (!data || !data[0] || !data[0].value || !data[0].value.result) {
                          // Leave the location as in location_key
                          return;
                      }

                      var result = data[0].value.result;

                        // Choose first item in the result as the place looking for
                        result = data[0].value.result;

                        if(result.address_components && result.address_components.length > 0 ){
                            location.description = googleMaps.getCityName(result.address_components);
                        }

                        // Defaulted to location key
                        $scope.locationLabel = location.description;

                    });
                  }
                }

                // A flag to block search until search params are ready
                // This is to block search until user location is ready to search nearby
                var blockSearch = true;

                // Enter Function
                $scope.init = function() {

                    hUser.refresh()
                        .then(function() {
                            if (hUser.isEmployer()) {
                                $scope.isEmployer = true;

                                $scope.groupFilters.push({
                                    displayName: $filter("translate")("shortlist"),
                                    code: 'shortlist',
                                    url : 'appLayout.harriSH.search.shortlist'
                                });
                            }else if(hUser.isLoggedIn()) {
                                $scope.memberWidgetExperienceLimit = 2;
                            }
                        })
                        .catch(function (err) {
                            // Do nothing, just to stop angularjs unhandled rejection error
                        });

                    // Ignore location from IP address/network e.g when a device location is available
                    var ignoreIPLocation = false;

                    // Start the page with requesting user location from IP
                    hUser.getUserLocation().then(function(data) {
                        if (!ignoreIPLocation) {
                            setSearchLocation(data, "network");
                        }
                    });

                    if (deviceChecker.isMobile()) {
                        // Ask user for his current location or fallback to server solution
                        hUser.getUserDeviceLocation().then(function(data){
                            ignoreIPLocation = true;
                            setSearchLocation(data, "device");
                        });
                    }

                    function setSearchLocation(data, locationSource){
                          // Unblock search
                        blockSearch = false;

                        // Trigger delayed search as the search was blocked before
                        $scope.doDelayedSearch();


                        // don't change the location if the url contains any location!
                        if( $scope.searchFiltersRequest.locations && $scope.searchFiltersRequest.locations.lat && $scope.searchFiltersRequest.locations.lng ){
                            $scope.appliedFilterValues.LOCATION = `${$scope.searchFiltersRequest.locations?.description || ''}${$scope.searchFiltersRequest.radius ? ' ' + $scope.searchFiltersRequest.radius.label : ''}`;
                            return;
                        }

                    }


                    if ($state.includes('appLayout.harriSH.search.shortlist') && hUser.isLoggedIn() && hUser.data.user.user_employer ) {
                      $scope.selectedGroupFilter = 'shortlist';
                      $scope.getSearchFilters();
                      return;
                    }

                    $scope.page = 0;

                    if ($state.includes('appLayout.harriSH.search.companies')) {
                        $scope.selectedGroupFilter = 'companies';
                    } else if ($state.includes('appLayout.harriSH.search.people')) {
                        $scope.selectedGroupFilter = 'members';
                    } else if ($state.includes('appLayout.harriSH.search.jobs')) {
                        $scope.selectedGroupFilter = 'jobs';
                    } else if ( $state.includes('appLayout.harriSH.search.apprentice-jobs')) {
                        $scope.selectedGroupFilter = 'apprentice_jobs';
                    } else if ($state.includes('appLayout.harriSH.search.pride-apprentice-jobs')) {
                        $scope.selectedGroupFilter = 'pride_apprentice_jobs';
                    } else{
                      $scope.selectedGroupFilter = 'all';
                    }

                    // Get Search Filters
                    $scope.getSearchFilters();

                    var urlParams = "";

                    if( $stateParams.filters ){
                        urlParams = $stateParams.filters;
                    }else if( SavedSearch.savedUrl ){
                        urlParams = SavedSearch.savedUrl;
                    }

                    var searchObj = parseUrlQuery(urlParams);

                    parseQuerySearchObject(searchObj);

                    $scope.page = 0;
                    $scope.isLoadMorePageDisabled = true;

                    $scope.changeFilter($scope.selectedGroupFilter);

                };

                var parseQuerySearchObject = function(searchObj) {
                    if (searchObj.query) {
                        $scope.searchFiltersRequest.keywords = searchObj['query'][0];
                    }
                    else {
                        $scope.searchFiltersRequest.keywords = "";
                    }

                    if (searchObj.skills) {
                        $scope.selectedFilters['skills'] = searchObj['skills'];
                        $scope.openedSections.skills = true;
                        $scope.isSelectedFilter.SKILLS = true;
                    }
                    else {
                        $scope.selectedFilters['skills'] = [];
                        $scope.openedSections.skills = false;
                        $scope.isSelectedFilter.SKILLS = false;
                    }
                    if (searchObj.degrees) {
                        $scope.selectedFilters['degrees'] = searchObj['degrees'];
                        $scope.openedSections.degrees = true;
                        $scope.isSelectedFilter.EDUCATION = true;
                    }
                    else {
                        $scope.selectedFilters['degrees'] = [];
                        $scope.openedSections.degrees = false;
                        $scope.isSelectedFilter.EDUCATION = false;
                    }
                    if (searchObj.cusine) {
                        $scope.selectedFilters['cusine'] = searchObj['cusine'];
                        $scope.openedSections.cusine = true;
                        $scope.isSelectedFilter.CUISINE = true;
                    }
                    else {
                        $scope.selectedFilters['cusine'] = [];
                        $scope.openedSections.cusine = false;
                        $scope.isSelectedFilter.CUISINE = false;
                    }

                    if (searchObj.hecs) {
                        $scope.selectedFilters['HECS'] = searchObj['hecs'];
                        $scope.openedSections.HECS = true;
                        $scope.isSelectedFilter.TYPE_OF_EXPERIENCE = true;
                    }
                    else {
                        $scope.selectedFilters['HECS'] = [];
                        $scope.openedSections.HECS = false;
                        $scope.isSelectedFilter.TYPE_OF_EXPERIENCE = false;
                    }

                    if (searchObj.positions) {
                        $scope.selectedFilters['positions'] = searchObj['positions'];
                        $scope.itHasPositions = true;
                        $scope.openedSections.positions = true;
                        $scope.isSelectedFilter.POSITIONS = true;

                        setSelectedPositionsFilters();
                    }
                    else {
                        $scope.selectedFilters['positions'] = [];
                        $scope.itHasPositions = false;
                        $scope.isSelectedFilter.POSITIONS = false;
                    }

                    if (searchObj.experience) {
                        $scope.searchFiltersRequest.years_of_experience = $scope.yearsOfExperience[searchObj.experience[0]];
                        $scope.openedSections.experience = true;
                    }
                    else {
                        $scope.searchFiltersRequest.years_of_experience = null;
                        $scope.openedSections.experience = false;
                    }

                    if (searchObj.availability) {

                        $scope.selectedAvailability = searchObj.availability;

                        angular.forEach( $scope.selectedAvailability , function( time , key ){
                            angular.forEach( $scope.availability , function( obj, key ){
                                if (obj.value == time) {
                                    obj.checked = true;
                                }
                            });
                        });
                        $scope.openedSections.availability = true;
                        $scope.isSelectedFilter.AVAILABILITY = true;
                    } else {
                        $scope.selectedAvailability = [];
                        $scope.openedSections.availability = false;
                        $scope.isSelectedFilter.AVAILABILITY = false;
                    }

                    if (searchObj.location) {
                        var latitude = searchObj.location[0];
                        var longitude = searchObj.location[1];

                        searchObj.location.splice(0, 2);



                        if (searchObj?.radius?.[0]) {
                            const matchedOption = $scope.locationDistanceOptions.find(option => option.value == searchObj.radius[0]);
                            if (matchedOption) {
                                $scope.searchFiltersRequest.radius = matchedOption;
                            }
                        }

                        $scope.searchFiltersRequest.locations = {
                            lat: latitude,
                            lng: longitude,
                            // Location key (label) might already contain commas, join the rest of the URL object
                            location_key: searchObj.location.join(","),
                            // label set to location key by default
                            description: searchObj.location.join(",")
                        }
                        $scope.isSelectedFilter.LOCATION = true;
                    }
                    else {
                        $scope.searchFiltersRequest.locations = {
                            description: ""
                        };
                    }
                }

                var changeUrlTimeOut = 0;


                $scope.changeUrl = function() {

                    $timeout.cancel(changeUrlTimeOut);

                    var searchObj = {};

                    if ($scope.searchFiltersRequest.keywords) {
                        searchObj['query'] = $scope.searchFiltersRequest.keywords;
                    }

                    if ($scope.selectedFilters.skills.length > 0) {
                        searchObj['skills'] = $scope.selectedFilters['skills'];
                    }
                    if ($scope.selectedFilters.degrees.length > 0) {
                        searchObj['degrees'] = $scope.selectedFilters['degrees'];
                    }

                    if ($scope.selectedFilters.cusine.length > 0) {
                        searchObj['cusine'] = $scope.selectedFilters['cusine'];
                    }

                    if ($scope.selectedFilters.HECS.length > 0) {
                        searchObj['hecs'] = $scope.selectedFilters['HECS'];
                    }

                    if ($scope.selectedFilters.positions.length > 0) {
                        searchObj['positions'] = $scope.selectedFilters['positions'];
                    }

                    // Don't update url if location is detected from user current location (auto detection)
                    if ($scope.searchFiltersRequest.locations &&
                        !$scope.searchFiltersRequest.locations.is_current &&
                        $scope.searchFiltersRequest.locations.location_key &&
                        $scope.searchFiltersRequest.locations.lat &&
                        $scope.searchFiltersRequest.locations.lng) {

                        searchObj['location'] = [];
                        searchObj.location.push($scope.searchFiltersRequest.locations.lat + '' || '');
                        searchObj.location.push($scope.searchFiltersRequest.locations.lng + '' || '');
                        searchObj.location.push($scope.searchFiltersRequest.locations.location_key + '' || '');

                        if ($scope.searchFiltersRequest.radius) {
                            searchObj['radius'] = $scope.searchFiltersRequest?.radius?.value;
                        }
                    }

                    var urlType;
                    switch ($scope.selectedGroupFilter) {
                        case 'all':
                            urlType = 'search';
                            break;
                        case 'members':
                            urlType = 'people';
                            break;
                        default:
                            urlType = $scope.selectedGroupFilter;
                            break;
                    }


                    if ($scope.selectedGroupFilter) {

                        if ($scope.selectedAvailability.length > 0) {
                            searchObj['availability'] = $scope.selectedAvailability;
                        }

                        if ($scope.searchFiltersRequest.years_of_experience) {
                            searchObj['experience'] = $scope.searchFiltersRequest.years_of_experience.value;
                        }
                    }


                    if (decodeURIComponent($state.href(".", {'filters': encodeUrlQuery(searchObj)})) != $location.path()) {
                        SavedSearch.savedUrl = encodeUrlQuery(searchObj);
                        $state.go(".", {'filters': encodeUrlQuery(searchObj)});
                    }
                };

                $scope.clearAvailability = function(time , $event){

                    $scope.toggleAvailability({ value : time }, $event);

                    for( var ind in  $scope.availability ){
                        if ( $scope.availability[ind].value == time ){
                            $scope.availability[ind].checked = false;
                        }
                    }



                }

                var setSelectedPositionsFilters = function(){

                  var index, setCategory;

                  angular.forEach($scope.positionsFiltersList, function (category, key) {

                    _.each( _.where(category.PositionType.Position,{'checked':true}) , function( position  ){  position.checked = false; });

                    angular.forEach($scope.selectedFilters['positions'], function (item, subkey) {

                      index = _.chain(category.PositionType.Position).pluck('code').indexOf(item).value();

                      if (index != -1 && category.PositionType.Position[index] != undefined) {
                        category.PositionType.Position[index].checked = true;
                        category.shown = true;
                        setCategory = true;
                      }
                    });

                    if (setCategory) {
                      $scope.positions.selectedCategory = category;
                      setCategory = false;
                    }

                  });

                  $scope.itHasPositions = false;

                }


                $scope.getSearchFilters = function () {

                    function handleSearchFiltersResponse(resp) {

                        $scope.searchFilters['positions'] = resp;

                        $scope.positionsFiltersList = resp;

                        if ($scope.itHasPositions) {

                            setSelectedPositionsFilters();

                        } else {
                            $scope.positions.selectedCategory = $scope.positionsFiltersList[0];
                        }
                    }

                    var positionsFiltersPromise = searchBackend.getPositionsFilters();

                    positionsFiltersPromise.then(function (res) {
                        handleSearchFiltersResponse(res);
                    });

                    function filtersHandler(resp) {

                        HStorageManager.put({
                            storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                            key: 'search_filters_1',
                            value: resp,
                            expiryDays: 30
                        });

                        if (resp.positions) {
                            delete resp.positions;
                        }
                        $scope.searchFilters = resp;

                        $timeout(function () {
                            $scope.$apply(function () {

                                var index;
                                angular.forEach($scope.selectedFilters, function (arr, key) {

                                    if (key != "positions") {
                                        angular.forEach(arr, function (item, innerKey) {

                                            index = _.chain($scope.searchFilters[key].filters).pluck('name').indexOf(item).value();
                                            if ($scope.searchFilters[key].filters[index]) {
                                                $scope.searchFilters[key].filters[index].checked = true;
                                                if(!$scope.searchFilters[key].selectedFilters){
                                                    $scope.searchFilters[key].selectedFilters = [];
                                                }
                                                $scope.searchFilters[key].selectedFilters.push($scope.searchFilters[key].filters[index]);
                                            }
                                        });
                                    }

                                });

                            });

                        }, 500)

                    }

                    var cachedSearchFiltersResponse = HStorageManager.get({
                        key: 'search_filters_1',
                        storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE
                    })
                    if (cachedSearchFiltersResponse) {
                        filtersHandler(cachedSearchFiltersResponse);
                    }
                    else {
                        var filtersPromise = searchBackend.getFilters();
                        filtersPromise.then(filtersHandler);
                    }

                };

                $scope.toggleSection = function( section ){

                    if ($.inArray(section, $scope.sectionsToToggle) != -1) {

                        if ( $scope.openedSections[ section ] ) {
                            $scope.openedSections[section] = false;
                        }else{
                            angular.forEach( $scope.sectionsToToggle , function( arrSection , key ){
                                $scope.openedSections[ arrSection ] = false;
                            });

                            $scope.openedSections[section] = true;

                            $timeout(function(){
                                $scope.$apply();
                            });
                        }

                    }else{
                       $scope.openedSections[section] = !$scope.openedSections[section];
                    }

                    if (section == 'experience' && $scope.openedSections[section] && !$scope.searchFiltersRequest.years_of_experience ) {
                        $scope.searchFiltersRequest.years_of_experience = $scope.yearsOfExperience[0];
                    }


                    if( section == 'positions' ){
                      $scope.doDelayedSearch();
                    }

                }


              /**
               * Nunjucks render functions
               */
              var templateEng = DispatcherServices.getNunjucks();

              var widgetsTmpls = {
                'members' : "../modules/search/views/nunjucks-partial/member_widget.tmpl.html",
                'companies' : "../modules/search/views/nunjucks-partial/company_widget.tmpl.html",
                'jobs' : "../modules/search/views/nunjucks-partial/job_widget.tmpl.html",
                'apprentice_jobs' : "../modules/search/views/nunjucks-partial/job_widget.tmpl.html",
                'pride_apprentice_jobs' : "../modules/search/views/nunjucks-partial/job_widget.tmpl.html"
              };

              var gridsTmpls = {
                'members' : "../modules/search/views/nunjucks-partial/people-result.tmpl.html",
                'companies' : "../modules/search/views/nunjucks-partial/companies-result.tmpl.html",
                'jobs' : "../modules/search/views/nunjucks-partial/jobs-result.tmpl.html",
                'apprentice_jobs' : "../modules/search/views/nunjucks-partial/jobs-result.tmpl.html",
                'pride_apprentice_jobs' : "../modules/search/views/nunjucks-partial/jobs-result.tmpl.html"
              };

              /**
               * Render the Grid with data
               * @param templateName
               */
              var renderGrid = function (templateName, data) {

                  var data = {'data': data, 'groupFilter': templateName};

                  if (templateName == 'members') {

                      data.isLoggedin = hUser.isLoggedIn();
                      data.isEmployer = ( hUser.data && hUser.data.user && hUser.data.user.user_employer ) || false;
                      data.selectedGroupFilter = $scope.selectedGroupFilter;
                      data.selectedToInvite = $scope.selectedToInvite;
                      data.shortListedUsers = $scope.shortListedUsers;
                      data.talentPoolCandidates = $scope.talentPoolCandidates || [];
                  }

                  var renderedHtml = templateEng.render(gridsTmpls[templateName], data);
                  var dataWrapper = '.' + templateName + '-grid';
                  var newCards = $compile(renderedHtml)($scope);

                  if ($(dataWrapper).length === 0) {
                      setTimeout(function () {
                          $(dataWrapper).append(newCards);
                          newCards.find(".application-widget-location span").each(function() {
                              var elm = $(this);
                              if (elm.height() > 40) {
                                  elm.parent().addClass("smaller");
                                  if (Utils.trimTextBasedOnHeight(elm, 40)) {
                                      var text = elm.text();
                                      elm.text(text.substring(0, text.length - 3));
                                      elm.append("...");
                                  }
                              }
                          });
                          PerformanceUtils.trackLoaded(hUser, $state);
                      }, 1);
                  } else {
                      $(dataWrapper).append(newCards);
                      newCards.find(".application-widget-location span").each(function() {
                          var elm = $(this);
                          if (elm.height() > 40) {
                              elm.parent().addClass("smaller");
                              if (Utils.trimTextBasedOnHeight(elm, 40)) {
                                  var text = elm.text();
                                  elm.text(text.substring(0, text.length - 3));
                                  elm.append("...");
                              }
                          }
                      });
                      PerformanceUtils.trackLoaded(hUser, $state);
                  }

                  $scope.searchResults[templateName].results = $scope.searchResults[templateName].results.concat(data.data);
              };

              /**
               * get single membert template
               */
              var getMemberCardHtml = function (member, callback) {

                  var data = {
                      'member': member,
                      'isLoggedin': hUser.isLoggedIn(),
                      'isEmployer': (hUser.data && hUser.data.user && hUser.data.user.user_employer ) || false,
                      'selectedGroupFilter': $scope.selectedGroupFilter,
                      'shortListedUsers': $scope.shortListedUsers,
                      'talentPoolCandidates': $scope.talentPoolCandidates || []
                  };

                  templateEng.render(widgetsTmpls.members, data, function (err, html) {
                      if (err) {
                          console.error(err);
                      }

                      callback(html);
                  });
              }





                $scope.doDelayedSearch = function(apply, delay) {

                  if (blockSearch) {
                      // Search is waiting for something (blocked)
                      return;
                  }

                    // Track delayed search, start tracking is only effective if not called before
                    PerformanceUtils.startTracking();
                  var searchDelay = delay || 700;
                  var searchTimeout = 'searchTimeout';

                  $timeout.cancel($scope.timeouts[searchTimeout]);

                  $scope.timeouts[searchTimeout] = $timeout(function(){
                    if( $scope && angular.isFunction( $scope.doSearch ) ){
                      $scope.doSearch(apply);
                    }
                  }, searchDelay);

                };


                var getCardsPerPage = function(filter) {

                    var peopleCardPerRow;
                    var peopleCardPerCol;

                    switch (filter) {
                        case 'members':
                            var cardWidth = ($(window).width() >= 1960)? 190: 176;
                            var cardHeight = ($(window).width() >= 1960)? 360: 336;
                            peopleCardPerRow = Math.floor(($(".search-right-area").innerWidth() - 70) / cardWidth);
                            peopleCardPerCol = Math.ceil($(".search-right-area").innerHeight() / cardHeight);
                            break;
                        case 'companies':
                        case 'jobs':
                        case 'apprentice_jobs':
                            var cardHeight = 273;
                            peopleCardPerRow = 5;
                            peopleCardPerCol = Math.ceil($(".search-right-area").innerHeight() / cardHeight);

                            break;
                        case 'pride_apprentice_jobs':
                            var cardHeight = 273;
                            peopleCardPerRow = 5;
                            peopleCardPerCol = Math.ceil($(".search-right-area").innerHeight() / cardHeight);

                            break;
                        default:
                            return 0;
                            break;
                    }

                    var cardsPerPage = peopleCardPerRow * peopleCardPerCol;

                    if (!$scope.page) {
                        cardsPerPage += peopleCardPerRow;
                    }

                    return cardsPerPage;
                }

              /**
               * Variable contains the sent request status
               * @type {boolean}
               */
              var afterRequestFail = false;


              $scope.doSearch = function(apply) {

                    if (blockSearch && !$scope.apiIsLoaded) {
                        // Search is waiting for something (blocked)
                        return;
                    }

                    if( $scope.selectedGroupFilter == "shortlist" ){
                      previousSearchGroup = angular.copy($scope.selectedGroupFilter);
                      return;
                    }

                    PerformanceUtils.startTracking(null, true);
                    params = {};

                    apply = apply || false;

                    if (!apply) {
                      $(".search-right-area").scrollTop(0);
                    }

                    params.search_phrase = $scope.searchFiltersRequest.keywords;


                  var cardsPerPage = getCardsPerPage($scope.selectedGroupFilter);

                  if($(window).width() >= 768 && cardsPerPage){
                      params.limitations = cardsPerPage;
                      params.offset = ($scope.page)? $scope.searchResults[$scope.selectedGroupFilter].results.length: 0;
                  }else{
                      params.limitations = $scope.currentLimitations[$scope.selectedGroupFilter];
                      params.offset = $scope.page * $scope.currentLimitations[$scope.selectedGroupFilter];
                  }

                    params.degrees = angular.copy( $scope.selectedFilters.degrees );
                    params.skills = angular.copy( $scope.selectedFilters.skills );
                    params.hecs = angular.copy( $scope.selectedFilters.HECS );
                    params.cusine = angular.copy( $scope.selectedFilters.cusine );
                    params.positions = angular.copy( $scope.selectedFilters.positions );


                    /**
                     * Set Category Search
                     * if no position selected
                     */
                    if( params.positions.length == 0 && $scope.positions && $scope.positions.selectedCategory && $scope.isSelectedFilter.POSITIONS && self.isPositionFilterApplied){
                      params.categories =  [$scope.positions.selectedCategory.PositionType.name];
                    }


                    if ($scope.selectedGroupFilter == 'members') {

                      params.onlyImages = $scope.onlyImages;

                      if ($scope.searchFiltersRequest.years_of_experience) {
                        params.experience = $scope.searchFiltersRequest.years_of_experience.value;
                      }

                      if ($scope.selectedAvailability.length > 0 ) {
                        params.availability = $scope.selectedAvailability;
                      }
                    }

                    var locationObj = $scope.searchFiltersRequest.locations;

                    if (locationObj && locationObj.lat && locationObj.lng) {
                        params.locations = [];
                        params.locations.push(locationObj.lat + '' || '');
                        params.locations.push(locationObj.lng + '' || '');
                    }

                    // If radius distance selected, append value to params
                    if ($scope.searchFiltersRequest.radius) {
                        params.radius = $scope.searchFiltersRequest.radius.value;
                    }

                    if ( $scope.selectedSortType && $scope.selectedSortType.field != "") {

                        params.sort = [];

                      /**
                       * Change Job sorting debending on publish date, not on created;
                       */
                        var sortField = $scope.selectedSortType.field;
                        if( ($scope.selectedGroupFilter == 'jobs' || $scope.selectedGroupFilter == 'apprentice_jobs'|| $scope.selectedGroupFilter == 'pride_apprentice_jobs')&& $scope.selectedSortType.field == 'created' ){
                          sortField = 'publish_date';
                        }
                        params.sort.push(sortField);
                        params.sort_type = $scope.selectedSortType.sort_type;


                        // Server doesn't accept location as sort critera (location object is sent instead)
                        if($scope.selectedSortType.field == 'location' ){
                          params.sort = [];
                        }

                    } else if ($scope.selectedSortType.field == '') {
                        params.sort = [];
                    }



                    // cancel the latest timeout
                    $timeout.cancel($scope.timeouts[name]);

                    $scope.loadingCalled = true;
                    if ( afterRequestFail || JSON.stringify(params) != previousSearchParams || $scope.selectedGroupFilter != previousSearchGroup ||
                        $scope.mainActiveTab != previousSelectedTab) {
                        // Apply filters in search object to URL, if search passed all the previous checks
                      $scope.changeUrl();
                      $scope.loading = true;

                      previousSearchParams = JSON.stringify(params);
                      previousSearchGroup = angular.copy($scope.selectedGroupFilter);
                      previousSelectedTab =  $scope.mainActiveTab;

                      $scope.isLoadMorePageDisabled = true;
                      var searchResult;
                      if ($scope.internalJobPostEnabled && $scope.mainActiveTab === 'myEmployerJobs') {
                          var request = CandidateAPI.searchInternalJobs(params);
                          var promise = { 'type' : 'jobs', 'promise' : request };
                          var returnedData = {'type': 'jobs', 'promises': []};
                          returnedData.promises.push(promise);
                          searchResult = returnedData;
                      } else {
                          searchResult = searchBackend.searchFor($scope.selectedGroupFilter, params, $scope.isLoggedin);
                      }

                      var promises = [];

                      $.each(searchResult.promises, function(index, promiseHolder) {

                        promises.push(promiseHolder.promise);

                        if (!apply) {
                          $('.' + searchResult.promises[index].type + '-grid').empty();
                          $scope.searchResults[searchResult.promises[index].type].results = [];
                          $('div[side-bar]').scrollTop(0);
                        }

                        promiseHolder
                          .promise
                          .then(function(resp) {

                              afterRequestFail = false;
                              resp.data = resp.data.data;

                              if (resp.data && resp.data.results && resp.data.results.length > 0) {
                                if ($scope.selectedGroupFilter == 'all') {
                                  $scope.resultsCount = $scope.defaultLimitations.all;
                                } else {
                                    $scope.resultsCount = $scope.resultsCount || {};
                                  $scope.resultsCount[searchResult.promises[index].type] = resp.data.hits;
                                }

                                if (!apply) {
                                  $('.' + searchResult.promises[index].type + '-grid').empty();
                                }

                                renderGrid(searchResult.promises[index].type, resp.data.results);
                                $scope.searchResults[searchResult.promises[index].type].count = resp.data.hits;

                                $scope.isLoadMorePageDisabled = false;
                              }
                              else {
                                $scope.isLoadMorePageDisabled = true;
                              }

                              $scope.searchResults[searchResult.promises[index].type].count = resp.data.hits;

                              if ($scope.selectedGroupFilter == 'all') {
                                $scope.resultsCount = angular.copy($scope.defaultLimitations.all);
                              } else {
                                $scope.resultsCount[searchResult.promises[index].type] = resp.data.hits;
                              }

                          },
                          function(){

                            /**
                             * if request failed due internet connection error
                             *  - set afterRequestFailed = true
                             *  - enable pagination
                             *  - reset the page counter to the prvious page
                             */

                            afterRequestFail = true;
                            $scope.isLoadMorePageDisabled = false;
                            $scope.page--;
                          });
                      });

                      $q.all(promises).then(function(){
                        $timeout(function(){
                          $scope.loading = false;
                          $scope.$apply();
                        })
                      });
                    }
                  else if (!$scope.loading) {
                      PerformanceUtils.reset();
                  }
                };

                $scope.switchSearchTabs = function(groupFilter){
                    $scope.changeFilter(groupFilter.code);
                    $state.go(groupFilter.url);
                };

                $scope.toggleAvailability = function( time , $event ){

                    $scope.page = 0;

                    var idx = $scope.selectedAvailability.indexOf(time.value);

                    if (time.checked) {
                      if (idx < 0) {
                        $scope.selectedAvailability.push(time.value);
                      }
                    }
                    else if (idx >= 0) {
                      $scope.selectedAvailability.splice(idx, 1);
                    }
                };

                $scope.applyAvailabilityFilter = function () {
                    $scope.appliedFilterValues.AVAILABILITY = getAvailabilityFilterValue();
                    $timeout(function () {
                        $scope.$apply();
                        $scope.doDelayedSearch();
                    });
                };


                $scope.onFilterChange = function (holder, filterCode) {
                    $timeout.cancel(toggleFiltersRef);
                    toggleFiltersRef = $timeout(function () {
                        $scope.page = 0;
                        if (holder == 'positions') {
                            if ($scope.searchFilters[holder].selectedFilters[0] && $scope.selectedCategories.indexOf($scope.searchFilters[holder].selectedFilters[0].position_type.code) == -1) {
                                $scope.selectedCategories.push($scope.searchFilters[holder].selectedFilters[0].position_type.code);
                            }
                            $scope.selectedFilters[holder] = _.pluck($scope.searchFilters[holder].selectedFilters, 'name');
                            $scope.positions.selectedCategory.PositionType.Position.map(function (record) {
                                record.checked = $scope.selectedFilters[holder].indexOf(record.name) > -1;
                            });
                        } else {
                            var filterValue;

                            if ($scope.searchFilters[holder].selectedFilters.length > 1) {
                                filterValue = $scope.searchFilters[holder].selectedFilters.length + ' ' + $filter('translate')('Selected');
                            } else if ($scope.searchFilters[holder].selectedFilters.length === 1) {
                                filterValue = $scope.searchFilters[holder].selectedFilters[0].name;
                            }
                            $scope.appliedFilterValues[filterCode] = filterValue;
                            $scope.selectedFilters[holder] = _.pluck($scope.searchFilters[holder].selectedFilters, 'name');
                            $scope.searchFilters[holder].filters.map(function (record) {
                                record.checked = $scope.selectedFilters[holder].indexOf(record.name) > -1;
                            });
                            $scope.$apply();
                            $scope.doDelayedSearch();
                        }
                    });
                };


                var toggleFiltersRef;
                $scope.toggleFilters = function (holder, id, $event, item) {
                    $timeout.cancel(toggleFiltersRef);
                    toggleFiltersRef = $timeout(function () {
                        $scope.page = 0;
                        if (!item || item && !item.checked) {
                            var idx = $scope.selectedFilters[holder].indexOf(id);
                            $scope.selectedFilters[holder].splice(idx, 1);
                        }
                        else if(item && item.checked){
                            $scope.selectedFilters[holder].push(id);
                        }

                        $scope.$apply();
                        $scope.doDelayedSearch();
                    });
                };

                $scope.toggleTagFilters = function( holder, id, $event ){

                    var index;
                    index = _.chain($scope.searchFilters[holder].filters).pluck('name').indexOf(id).value();
                    if($scope.searchFilters[holder].filters[index]){
                        $scope.searchFilters[holder].filters[index].checked = false;
                        var items = [];
                        $scope.searchFilters[holder].selectedFilters.forEach(function (item) {
                            if(item.name !== id){
                                items.push(item)
                            }
                        });
                        $scope.searchFilters[holder].filters = angular.copy($scope.searchFilters[holder].filters);
                        $scope.searchFilters[holder].selectedFilters = angular.copy(items);
                    }
                    $scope.toggleFilters(holder, id, $event);
                };

                $scope.togglePositionsTagFilters = function( position , $event ){
                    var index;
                    index = _.chain($scope.positions.selectedCategory.PositionType.Position).pluck('name').indexOf(position).value();
                    if (index != -1 ) {
                        var items = [];
                        $scope.searchFilters['positions'].selectedFilters.forEach(function (item) {
                            if(item.name !== position){
                                items.push(item)
                            }
                        });
                        $scope.positions.selectedCategory.PositionType.Position = angular.copy($scope.positions.selectedCategory.PositionType.Position);
                        $scope.searchFilters['positions'].selectedFilters = angular.copy(items);
                        $scope.positions.selectedCategory.PositionType.Position[index].checked = false;
                        $scope.togglePositionFilters( $scope.positions.selectedCategory , position , $event);
                    }
                };


                var togglePositionFiltersTO;
                $scope.togglePositionFilters = function (parentCategory, position, $event, item) {
                    $timeout.cancel(togglePositionFiltersTO);
                    togglePositionFiltersTO = $timeout(function () {
                        $scope.selectedCategories.push(parentCategory);

                        if (!item || item && !item.checked) {
                            var idx = $scope.selectedFilters['positions'].indexOf(position);
                            $scope.selectedFilters['positions'].splice(idx, 1);
                        }
                        else if(item && item.checked){
                            $scope.selectedFilters['positions'].push(position);
                        }
                    });

                };

                var getAvailabilityFilterValue = function () {
                    var filterValue;

                    if ($scope.selectedAvailability.length === 1) {
                        if ($scope.selectedAvailability[0] === 'any_time') {
                            filterValue = $filter('translate')('Anytime');
                        } else if ($scope.selectedAvailability[0] === 'full_time') {
                            filterValue = $filter('translate')('Full time');
                        } else if ($scope.selectedAvailability[0] === 'part_time') {
                            filterValue = $filter('translate')('Part time');
                        }
                    } else if ($scope.selectedAvailability.length > 1) {
                        filterValue = $scope.selectedAvailability.length + ' ' + $filter('translate')('Selected');
                    }

                    return filterValue;
                };

                $scope.clearKeyword = function(){
                    $scope.searchFiltersRequest.keywords = '';
                    $scope.watcher();
                    $scope.doSearch();
                }

                $scope.clearLocation = function(){
                    $scope.searchFiltersRequest.locations = null;
                    $scope.locationLabel = '';
                }

                $scope.removeFilter = function (filterCode) {
                    delete $scope.isSelectedFilter[filterCode];
                    delete $scope.appliedFilterValues[filterCode];

                    switch (filterCode) {
                        case 'LOCATION':
                            $scope.clearLocation();
                            $scope.clearRadius();
                            break;

                        case 'POSITIONS':
                            $scope.positions.selectedCategory = null;
                            $scope.searchFilters.positions.selectedFilters = [];
                            $scope.selectedFilters.positions = [];
                            self.isPositionFilterApplied = false;
                            break;

                        case 'AVAILABILITY':
                            $scope.availability.forEach(function (time) {
                                time.checked = false;
                            });
                            $scope.selectedAvailability = [];
                            break;

                        case 'TYPE_OF_EXPERIENCE':
                            $scope.searchFilters.HECS.selectedFilters = [];
                            $scope.selectedFilters.HECS = [];
                            $scope.searchFilters.HECS.filters.forEach(function (hec) {
                                hec.selected = false;
                            });
                            break;

                        case 'YEARS_OF_EXPERIENCE':
                            $scope.clearExperience();
                            break;

                        case 'SKILLS':
                            $scope.searchFilters.skills.selectedFilters = [];
                            $scope.selectedFilters.skills = [];
                            $scope.searchFilters.skills.filters.forEach(function (skill) {
                                skill.selected = false;
                            });
                            break;

                        case 'CUISINE':
                            $scope.selectedFilters.cusine = [];
                            $scope.searchFilters.cusine.selectedFilters = [];
                            $scope.searchFilters.cusine.filters.forEach(function (cuisine) {
                                cuisine.selected = false;
                            });
                            break;

                        case 'EDUCATION':
                            $scope.searchFilters.degrees.filters.forEach(function (degree) {
                                degree.selected = false;
                            })
                            $scope.searchFilters.degrees.selectedFilters = [];
                            $scope.selectedFilters.degrees = [];
                            break;

                        case 'PROFILE_IMAGE':
                            $scope.onlyImages = false;
                            break;
                    }

                    $scope.doSearch();
                };


                $scope.clearRadius = function () {
                    $scope.searchFiltersRequest.radius = $scope.locationDistanceOptions[DEFAULT_SELECTED_DISTANCE_INDEX];
                }

                $scope.clearExperience = function(){
                    $scope.searchFiltersRequest.years_of_experience = "";
                }

                $scope.resetFilters = function( keepUserLocation ){
                    // Keep selected filters reset at the beginning, changing the poisitions of this might trigger search before reset
                    $scope.selectedFilters = $scope.initFilters();

                    // Reset radius search filter to default (first option in distance options)
                    $scope.searchFiltersRequest.radius = $scope.locationDistanceOptions[DEFAULT_SELECTED_DISTANCE_INDEX];

                    if ($scope.searchFiltersRequest.keywords != '') {
                        $scope.clearKeyword();
                    }

                    if ($scope.searchFiltersRequest.locations) {
                      if( !keepUserLocation || ( keepUserLocation &&  !$scope.searchFiltersRequest.locations.is_current ) ){
                        $scope.clearLocation();
                      }
                    }

                    _.each($scope.searchFilters, function(searchFilters){
                        _.each(searchFilters.filters, function(filter){
                            filter.checked = false;
                        });
                        searchFilters.filters = angular.copy(searchFilters.filters);
                        searchFilters.selectedFilters = [];
                    });

                    if ($scope.positions.selectedCategory) {
                        _.each($scope.positions.selectedCategory.PositionType.Position, function(obj){
                            obj.checked = false;
                        });
                    }

                    if ($scope.searchFiltersRequest.years_of_experience) {
                        $scope.clearExperience();
                    }

                    if ($scope.selectedAvailability.length) {
                        var avail = angular.copy($scope.selectedAvailability);
                        for( var ind in  avail ){
                            $scope.clearAvailability( avail[ind] , null  );
                        }
                        $scope.selectedAvailability = [];
                    }

                    $scope.searchFilters.positions = {};
                    $scope.searchFilters.positions.selectedFilters = [];
                    $scope.selectedFilters.positions = [];
                    $scope.positions.selectedCategory = {};
                    self.isPositionFilterApplied = false;
                    if ($scope.positions.selectedCategory.PositionType) {
                        $scope.positions.selectedCategory.PositionType.Position = angular.copy($scope.positions.selectedCategory.PositionType.Position);
                    }

                    $scope.openedSections.positions = false;

                    $scope.isSelectedFilter = {};
                    $scope.doDelayedSearch(false, 1);
                }

                $scope.init();


                $scope.$watch( 'positions.selectedCategory' , function( newVal , oldVal ){

                    if (newVal && oldVal && oldVal.PositionType && newVal.PositionType && (newVal.PositionType.name != oldVal.PositionType.name )) {

                        if($scope.selectedFilters.positions.length > 0 ){

                            var index;
                            var positions = angular.copy($scope.selectedFilters.positions);

                            angular.forEach($scope.positionsFiltersList, function(cate , key){

                                angular.forEach(positions, function(position,key){

                                    index = _.chain(cate.PositionType.Position).pluck('name').indexOf(position).value();

                                    if (index != -1 ) {
                                        cate.PositionType.Position[index].checked = false;
                                        $scope.togglePositionFilters( cate , position , null);
                                    }

                                    $scope.togglePositionsTagFilters( position, null );
                                });

                            });

                            $scope.searchFilters.positions.selectedFilters = [];
                            $scope.selectedFilters.positions = [];

                            $timeout(function(){
                                $scope.$apply();
                            });


                        }

                    }
                });


                $scope.watcher = function(data) {
                    data = data || false;
                    $scope.page = 0;
                    $scope.currentLimitations = angular.copy($scope.defaultLimitations[$scope.selectedGroupFilter]);
                    // $scope.changeUrl();
                }

                $scope.toggleImagesFlag = function () {
                    $scope.onlyImages = !$scope.onlyImages;
                };

                $scope.applyImageFilter = function () {
                    $scope.appliedFilterValues.PROFILE_IMAGE = $scope.onlyImages ? $filter('translate')('Only images') : $filter('translate')('All');
                    $scope.watcher();
                    $scope.doSearch();
                };

                $scope.$watchCollection('searchFiltersRequest', function( newVal ){ $scope.watcher(newVal) });
                $scope.$watchCollection('selectedFilters', function( newVal ){ $scope.watcher(newVal) });

                $scope.applySearchFilters = function (newVal) {
                    $scope.watcher(newVal);
                };


                $scope.$watchCollection('selectedGroupFilter', function(newVal, oldVal){

                    if (newVal != 'members' && (newVal != oldVal)) {

                        $scope.selectedAvailability = [];
                        $scope.searchFiltersRequest.years_of_experience = null;

                        $scope.openedSections.availability = false;
                        $scope.openedSections.experience = false;

                        for( var ind in $scope.availability){
                            $scope.availability[ind].checked = false;
                        }

                    };
                    $scope.watcher();
                });

                $scope.applyLocationFilter = function () {
                    var newVal = $scope.searchFiltersRequest.locations;
                    var defer = $q.defer();

                    $scope.appliedFilterValues.LOCATION = $scope.searchFiltersRequest.locations && $scope.searchFiltersRequest.locations.description + ($scope.searchFiltersRequest.radius ? ' ' + $scope.searchFiltersRequest.radius.label : '');
                    //Select Distance Sort
                    var sortByDistanceIndex = _.indexOf( $scope.sortedBy, _.findWhere( $scope.sortedBy, {'field' : 'location'} ) );
                    if( newVal && newVal.lat && newVal.lng && sortByDistanceIndex != -1 ){
                      $scope.selectedSortType = $scope.sortedBy[sortByDistanceIndex];
                    }

                    if( newVal ){

                      if( !newVal.lat  || !newVal.lng ){

                        googleMaps.googleServicePromise().then(function(){

                            // hEvent.track("geocode", { category: 'google_apis', label: 'search' });
                          googleMaps.geocoder.geocode({address : newVal.description} , function( resp , status ){
                            if( resp[0] ){
                              defer.resolve(resp[0]);
                            }
                            else{
                              defer.resolve({});
                            }

                          });

                        });

                      }else{
                        defer.resolve(newVal);
                      }

                    }
                    else if (!newVal) {
                      //$scope.searchFiltersRequest.locations = null;
                      $scope.locationLabel = '';

                      $scope.doDelayedSearch();
                    }

                    defer.promise.then(function( returnedLocation ){
                      $scope.doDelayedSearch();
                      if (returnedLocation) {
                        if (returnedLocation.geometry && returnedLocation.geometry.location) {
                          newVal.lat = returnedLocation.geometry.location.lat();
                          newVal.lng = returnedLocation.geometry.location.lng();

                          if (returnedLocation.address_components) {
                            newVal.location_key = googleMaps.getCityName(returnedLocation.address_components);
                            newVal.description = newVal.location_key;
                          }
                          else {
                            newVal.location_key = returnedLocation.formatted_address.replace(/,/g, "");
                          }
                        }

                        // If we have a location without a label, trying to reverse geocode to get the address label
                          if (newVal.lat && newVal.lng && !newVal.description) {
                              $timeout.cancel(locationTimeoutPromise);
                              locationTimeoutPromise = $timeout(function(){
                                  getLocationName(newVal);
                              }, minInterval);
                            }
                      }
                    });

                    $scope.doDelayedSearch();
                };

                $scope.$watch('selectedSortType', function(newval, oldval) {
                    $scope.changeSort();
                });

                $scope.applyYearsOfExperienceFilter = function () {
                    $scope.appliedFilterValues.YEARS_OF_EXPERIENCE = $scope.searchFiltersRequest.years_of_experience.label;
                    $scope.watcher($scope.searchFiltersRequest.years_of_experience);
                    $scope.doDelayedSearch();
                };


              /**
               * Watch Internet Connection
               */
              var internetOnlineHandler = $rootScope.$on('InternetOnline',function(){
                /*
                  Do Search if the search still loading
                  or there is no returned results
                  when the connection returned back
                 */
                if( $scope.loading ||
                  ( $scope.searchResults[ $scope.selectedGroupFilter ] && $scope.searchResults[ $scope.selectedGroupFilter ].results && $scope.searchResults[ $scope.selectedGroupFilter ].results.length == 0 ) ){
                  $scope.doSearch();
                }

              });

                $scope.$on('$destroy', function(){
                    // Unsubscribe rootScope event (internet online)
                    internetOnlineHandler();

                    $timeout(function(){
                        $scope = $rootScope.$new();
                    });
                });

            }
        ])
    .constant('parseUrlQuery', function(filters, keys) {

        if (!filters) {
            return {};
        }

        filters = filters.replace(/~2F/gi, "/");
        // filters = filters.replace(/%2F/gi, "/");

        filters = filters.split('/');

        let filtersKeys = keys || ['query', 'location', 'radius', 'skills','degrees', 'hecs', 'cusine', 'positions','availability','experience', 'page', 'sort', 'sort_type'];
        var filterObject = {};

        //parse route params
        for (var k in filters) {
            var filter = filters[k];
            if (_.contains(filtersKeys, filter)) {
                var index = parseInt(k);
                if (filters[index + 1]) {
                    var value = decodeURIComponent(filters[index + 1]);
                    if (!_.contains(filtersKeys, value)) {
                        if (value.indexOf(",") >= 0) {
                            value = value.split(",");
                            for (var kk in value) {
                                value[kk] = value[kk];
                            }
                        } else {
                            value = Array(value);
                        }
                        filterObject[filter] = value;
                    }
                }
            }
        }
        return filterObject;
    })
    .constant('encodeUrlQuery', function(filterObject) {
        //encode params to URL
        var url = "";
        for (var k in filterObject) {
            var value = filterObject[k];
            if (angular.isArray(value)) {
                value = value.join(",");
            }

            url += "/" + k + "/" + encodeURIComponent(value);

        }
        return url;
    }).service('SavedSearch', [function(){
        this.savedUrl = "";
    }]);
